import { Box, AlertBox } from '@origin-digital/style-guide';

import React from 'react';

import { FormErrorSummaryProps } from './FormErrorSummary.types';

const FormErrorSummary: React.StatelessComponent<FormErrorSummaryProps> = ({
  ...props
}: FormErrorSummaryProps): JSX.Element | null => {
  const { graphMessage, graphError, marginBottom } = props;
  if (!graphError) {
    return null;
  }

  return (
    <Box marginBottom={marginBottom} width={'100%'} display={'flex'} justifyContent={'center'}>
      <Box column={12} smColumn={12} mdColumn={8} lgColumn={8}>
        <AlertBox type={'error'} message={graphMessage} />
      </Box>
    </Box>
  );
};

export { FormErrorSummary as default };
